export type PracticeAchievementData = {
  key: string;
  target: number;
  current: number;
  unlocked: string | null;
};

export type PracticeProgressData = {
  today: string;
  completedToday: boolean;
  streak: number;
  totalDays: number;
  totalSessions: number;
  totalPersonalSessions: number;
  achievements: PracticeAchievementData[];
  daysThisWeek: number;
  nextPracticeDate: string | null;
  week: { date: string; practiced: boolean; today: boolean; future: boolean }[];
};

export type DailyPracticeStatus = {
  progress: PracticeProgressData;
  offer: "resume" | "revisit" | "personal" | "collection";
  moveIndex?: number;
};

export function browserPracticeTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
}
